import React, { useEffect } from 'react'
import { Container, Image } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { userManager } from 'utils/authHelpers'
import { FooterLoggedOut } from 'components/footer-blocks/footer-logged-out/FooterLoggedOut'
import { appRoutes } from 'constants/routes/appRoutes'
import { setFullMobileViewHeight } from 'utils/commonhelpers'
import nordic_white from 'img/tf-logos/tf-nordic-logo-white.svg'
import Imageshiftperseason from 'components/backgroundImgShift/Imageshiftperseason'
import './LogoutCallbackPage.scss'

function LogoutCallbackPage() {
	setFullMobileViewHeight()

	const { t } = useTranslation()
	const logo = nordic_white
	const navigate = useNavigate()

	useEffect(() => {
		userManager.signoutRedirectCallback().then(() => {
			sessionStorage.clear()
		})
		userManager.clearStaleState()
	}, [])

	return (
		<div id="logout-callback-page">
			<Imageshiftperseason>
				<div className="logout-container">
					<Image
						src={logo}
						className="tfbank-logo logout"
						alt="TF Nordic AB"
					/>
					<Container className="logout-body">
						<h2>{t('LoggedOut')}</h2>
						<button
							className="btn btn-outline-lightgray"
							onClick={() => navigate(appRoutes.login)}>
							{t('Login')} <FontAwesomeIcon icon="sign-in-alt" />
						</button>
					</Container>
					<FooterLoggedOut />
				</div>
			</Imageshiftperseason>
		</div>
	)
}
export default LogoutCallbackPage